import { render, staticRenderFns } from "./ReturnLayer.vue?vue&type=template&id=06d8f028&scoped=true&"
import script from "./ReturnLayer.vue?vue&type=script&lang=js&"
export * from "./ReturnLayer.vue?vue&type=script&lang=js&"
import style0 from "./ReturnLayer.vue?vue&type=style&index=0&id=06d8f028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8f028",
  null
  
)

export default component.exports